import { render, staticRenderFns } from "./COAAddVendorClientMultiCurrencyAllocationModal.vue?vue&type=template&id=3e1d0b28&scoped=true&"
import script from "./COAAddVendorClientMultiCurrencyAllocationModal.vue?vue&type=script&lang=js&"
export * from "./COAAddVendorClientMultiCurrencyAllocationModal.vue?vue&type=script&lang=js&"
import style0 from "./COAAddVendorClientMultiCurrencyAllocationModal.vue?vue&type=style&index=0&id=3e1d0b28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1d0b28",
  null
  
)

export default component.exports